/**
 * Shopping feature — public API
 */

// Components
export { ProductCard } from "./components/ProductCard";
export { FilterSidebar, FilterSheetTrigger } from "./components/FilterSidebar";
export { ProductList } from "./components/ProductList";
export { ProductListSkeleton } from "./components/ProductListSkeleton";
export { ShoppingContent } from "./components/ShoppingContent";

// Queries
export {
  productKeys,
  useProducts,
  useProductSearch,
  useToggleFavorite,
} from "./queries/useProducts";
export { prefetchProducts } from "./queries/prefetch";
